<div class="flex h-full min-h-0 flex-col gap-4">
  <div class="relative mb-4">
    <div class="custom-form custom-form-readonly">
      <app-hashtag
        [analyticsKeywordCounts]="getKeywordCount"
        [form]="deliverableForm()"
        [creatorId]="executionAnalytics()?.creatorId"
        [isCustomMode]="true"
        [creators]="[]"
        [isViewMode]="true"
        [isExpanded]="true"
        [showStatusBadge]="executionAnalytics()?.status !== EMatchingType.planned"
        [manualDeliverableStatusConfig]="manualDeliverableStatusConfig()"
      />
    </div>
  </div>

  @if (manualDeliverableStatusConfig().analyticsVisible) {
    <div class="flex min-h-0 flex-1 flex-col">
      <h3 class="text-sm font-bold">
        {{ 'pages.campaignDetails.ctaAnalytics.details.detected' | translate }}
        {{ 'pages.campaignDetails.ctaAnalytics.deliverable.' + deliverableType + '.title' | translate | lowercase }}
      </h3>

      <app-analytics-details-table
        matSort
        [dataSource]="dataSource"
        [dataCount]="dataCount()"
        [displayedColumns]="displayedColumns"
        [sort]="sort()"
      >
        <ng-container matColumnDef="text">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'pages.campaignDetails.ctaAnalytics.details.hashTag.title' | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            class="font-bold text-sm"
            [innerHTML]="highlightKeywords(element.text, getActiveKeywords(element))"
          ></td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <div class="flex items-center justify-end gap-1">
              @if (manualFindingStatusStore) {
                @if (hasRowPendingDeletions(element)) {
                  @if (isVisualizerActing(element.id)) {
                    <app-dots-spinner />
                  } @else {
                    <button
                      mat-icon-button
                      class="mat-secondary-gray-border-button-color"
                      (click)="onRevertRow(element); $event.stopPropagation()"
                    >
                      <app-icon src="/icons/redo.svg" alt="Revert" [size]="16" />
                    </button>
                  }
                }
                @if (canDelete() && hasRowActiveFinding(element)) {
                  <button
                    mat-icon-button
                    class="mat-secondary-gray-border-button-color"
                    [matMenuTriggerFor]="deleteMenu"
                    (click)="$event.stopPropagation()"
                  >
                    <app-icon src="/icons/trash.svg" alt="Delete" [size]="16" />
                  </button>
                  <mat-menu #deleteMenu="matMenu">
                    <button mat-menu-item (click)="onDeleteAllFindings(element)">
                      {{ 'shared.deleteAll' | translate }}
                    </button>
                    @for (item of buildDeleteMenuItems(element); track item.findingId) {
                      @if (isFindingInFlight(item.findingId)) {
                        <button mat-menu-item [disabled]="true">
                          <app-dots-spinner />
                        </button>
                      } @else {
                        <button mat-menu-item (click)="onDeleteFinding(item.findingId, element)">
                          {{ 'shared.delete' | translate }} {{ item.label }}
                        </button>
                      }
                    }
                  </mat-menu>
                }
              }
            </div>
          </td>
        </ng-container>
      </app-analytics-details-table>
    </div>
  }
</div>
